"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortChangeHandler = exports.sortAnswerData = exports.sortData = void 0;

var sortData = function sortData(a, b, container) {
  var _container$state = container.state,
      sortColumn = _container$state.sortColumn,
      sortDirection = _container$state.sortDirection;
  var direction = sortDirection === 'ascending' ? 1 : -1;

  if (!sortColumn) {
    return 0;
  }

  if (a.belowSample) {
    return 1;
  }

  if (b.belowSample) {
    return -1;
  }

  if (a && a[sortColumn] && isNaN(a[sortColumn]) && b && b[sortColumn] && isNaN(b[sortColumn])) {
    if (a[sortColumn].toLowerCase() < b[sortColumn].toLowerCase()) {
      return -1 * direction;
    } else if (a[sortColumn].toLowerCase() > b[sortColumn].toLowerCase()) {
      return direction;
    } else {
      return 0;
    }
  }

  return direction * (a[sortColumn] - b[sortColumn]);
};

exports.sortData = sortData;

var sortAnswerData = function sortAnswerData(a, b, selectedMeasure, container) {
  var _container$state2 = container.state,
      sortColumn = _container$state2.sortColumn,
      sortDirection = _container$state2.sortDirection;
  var direction = sortDirection === 'ascending' ? 1 : -1;

  if (!sortColumn) {
    return 0;
  }

  if (a.answers[sortColumn].belowSample) {
    return 1;
  }

  if (b.answers[sortColumn].belowSample) {
    return -1;
  }

  if (a.answers[sortColumn][selectedMeasure] < b.answers[sortColumn][selectedMeasure]) {
    return -1 * direction;
  } else if (a.answers[sortColumn][selectedMeasure] > b.answers[sortColumn][selectedMeasure]) {
    return direction;
  } else {
    return 0;
  }
};

exports.sortAnswerData = sortAnswerData;

var sortChangeHandler = function sortChangeHandler(clickedColumn, container) {
  var _container$state3 = container.state,
      sortColumn = _container$state3.sortColumn,
      sortDirection = _container$state3.sortDirection;

  if (sortColumn !== clickedColumn) {
    container.setState({
      sortColumn: clickedColumn,
      sortDirection: 'descending'
    });
    return;
  }

  container.setState({
    sortDirection: sortDirection === 'ascending' ? 'descending' : 'ascending'
  });
};

exports.sortChangeHandler = sortChangeHandler;